import React from 'react'

import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

function ReachLineChart({ header = 'Header Text', data = [], XAxisDataKey='pv', YAxisDataKey = 'name' }) {

  return (
    <>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 5, right: 0, bottom: 5, left: 0 }}>
          <Line type="monotone" dataKey={YAxisDataKey} stroke="#8884d8" />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey={XAxisDataKey} />
          <YAxis />
          <Tooltip />
        </LineChart>
      </ResponsiveContainer>
    </>
  )
}

export default ReachLineChart